import type { PlatformModel } from "@/api/orval/model";

export const getIntercomCompany = (
  platform: Pick<PlatformModel, "name" | "salesforceAccountId"> | null | undefined,
): Intercom_.IntercomCompany | undefined => {
  if (!platform) return undefined;

  const companyId = platform.salesforceAccountId?.trim();
  if (!companyId) return undefined;

  // Intercom's Salesforce sync matches Company ID to Salesforce Account Id.
  return { company_id: companyId, name: platform.name };
};
